module.exports = __webpack_public_path__ + "static/media/home_banner_5.69bd6948.jpg";